import en from './english.json'
import es from './spanish.json'

export const dictionaryList = { en, es }

export const languageOptions = {
    en: 'English',
    es: 'Español'
}
